__turbopack_context__.v({
  "cartListItem": "CartListItem-module-scss-module__5FMVRa__cartListItem",
  "qty": "CartListItem-module-scss-module__5FMVRa__qty",
  "remove": "CartListItem-module-scss-module__5FMVRa__remove",
  "visuallyHidden": "CartListItem-module-scss-module__5FMVRa__visuallyHidden",
});
